import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import {
  ListingSearchClient,
  SearchRequest,
  SearchResultOfBaseSearchModel,
} from "../../openApiClients/generated/EngineeringUK.Sites";
import { until } from "lit/directives/until.js";
import { SearchBaseComponent } from "./SearchBaseComponent";

@customElement("euk-search-type-ahead")
export class SearchTypeAheadComponent extends SearchBaseComponent {
  @property({ type: String })
  fallbackMessage?: string;

  @property({ type: String })
  baseUrl?: string;

  @property({ type: Object })
  request?: SearchRequest;

  currentRequest?: SearchRequest;

  currentResult?: SearchResultOfBaseSearchModel;
  private client: ListingSearchClient;

  connectedCallback() {
    super.connectedCallback();
    this.addListener<SearchRequest>(this.requestUpdateEvent, async (e) => {
      this.currentRequest = e.detail;
      this.currentResult = undefined;
      this.updateRequestUrl(this.currentRequest);
      await this.search();
    });
  }

  constructor() {
    super();
    this.client = new ListingSearchClient(this.baseUrl);
  }

  private async updateTerm(e: Event & { target: HTMLInputElement }) {
    if (!this.currentRequest) {
      return;
    }
    this.currentRequest.term = e.target.value;
    this.currentResult = undefined;
    this.triggerEvent(this.currentRequest, this.requestUpdateEvent);
    await this.search();
  }

  async search() {
    if (!this.currentRequest) {
      return;
    }
    if (this.currentResult) {
      return;
    }
    if (this.currentRequest.filters) {
      for (let i = 0; i < this.currentRequest.filters.length; i++) {
        const filter = this.currentRequest.filters[i];
        if (filter.options) {
          filter.options = filter.options.filter(x => x.selected);
        }
      }
    }
    this.currentResult = await this.client.search(this.currentRequest);
    this.triggerEvent(this.currentResult, this.resultUpdateEvent);
    this.requestUpdate();
  }

  render() {
    this.currentRequest = this.request;
    return html`
      ${super.render()}
      <input type="text" .value="${this.request?.term ?? ""}" @input="${this.updateTerm}">
      <div id="results">
        <slot name="beforeResults"></slot>
        ${until(this.search().then(() => html`
          <div class="grid listing__items">
            ${!this.currentResult?.items
              ? html`<h2 class="grid__no-results reduced">${this.fallbackMessage}</h2>`
              : html`
                ${Object.entries(this.currentResult?.items).map(([key, val]) => {
                  return html`
                    <div class="grid__item listing__item listing__item-${key}">

                      <a href="${val.url}" class="listing__link">
                        <slot name="result"></slot>
                        ${val.image ? html`<img src="${val.image}" alt="${val.name}" class="listing__image">` : null}
                        <h2 class="listing__heading">
                          ${val.name}
                        </h2>
                      </a>
                    </div>`;
                })}`}
            <slot name="afterResults"></slot>
          </div>
        `), html`<slot name="loading">Results are loading</slot>`)}

    `;
  }
}
